module.exports = __webpack_public_path__ + "static/media/icon-user.8139d8df.svg";